
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * QuoteType enum
 */
class QuoteType {
  /**
   * Initialize enum with a given value
   * @param {QuoteType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof QuoteType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!QuoteType}
   * @param {!QuoteType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof QuoteType)) {
      throw new TypeError('Instance of QuoteType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!QuoteType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!QuoteType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === QuoteType.BID.value) {
      return 'BID'
    }
    if (this.value === QuoteType.ASK.value) {
      return 'ASK'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!QuoteType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!QuoteType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!QuoteType} Created enum
   */
  static fromObject (other) {
    return new QuoteType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
QuoteType.BID = new QuoteType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
QuoteType.ASK = new QuoteType(0 + 1)

export { QuoteType };

/**
 * Fast Binary Encoding QuoteType field model
 */
class FieldModelQuoteType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelQuoteType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelQuoteType}
   * @param {QuoteType=} defaults Default value, defaults is new QuoteType()
   * @returns {!QuoteType} Result value
   */
  get (defaults = new QuoteType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new QuoteType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelQuoteType}
   * @param {!QuoteType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelQuoteType };
